import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './ga-w4.component.html';
import { SignaturePadModal } from '../signature/signature-pad.component';
import moment from 'moment';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import { InfoModal } from '../info-modal/info-modal.component';
import { OwnerPreviewSignatureModal } from '../preview-signature-modal/owner-preview-signature-modal.component';

export const GaW4Component = {
    templateUrl,
    controller: GaW4Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        ownerInfo: "<",
        stateTaxInfo: "<",
        showSignaturePopup: "<",
        close: "&",
        dismiss: "&"
    }
}

function GaW4Controller(onboardingActionPolicy, onboardingDocumentService, $state, $scope, $uibModal, $q, utilityService, localeService, onboardingDocumentViewService, employeeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('2', vm.application) === 'View';
    vm.taxForm;
    const GA_STATE_ID = 12;

    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onDocDownload = onDocDownload;
    vm.onSubmit = onSubmit;
    vm.onShowFederalW4 = onShowFederalW4;
    vm.onShowI9 = onShowI9;
    vm.onRequestReview = onRequestReview;
    vm.onSign = onSign;
    vm.onSave = onSave;
    //vm.onTotalAllowancesBlur = autofillTotalAllowancesOnFinalize;
    vm.syncFormToProfile = syncFormToProfile;
    vm.onExemptChange = onExemptChange;
    vm.step4Filled = step4Filled;
    vm.step5Filled = step5Filled;
    vm.onEditClicked = onEditClicked;
    vm.revealSSNChar = revealSSNChar;
    vm.revealFEINChar = revealFEINChar;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.ssnIsValidated = ssnIsValidated;
    vm.ssnBlur = ssnBlur;
    vm.formatSsn = formatSsn;
    vm.onClose = onClose;

    vm.reqReview = false;
    vm.isSigned = false;
    vm.isSaved = false;
    vm.prefilled = false;
    vm.editable = true;
    vm.disableEmpFields = true;
    vm.savedData = false;
    vm.showSavedNotification = false;
    vm.previewUrl;
    vm.isExempt = false;
    vm.stateWitholdingTypeID = 5; // DB WithholdingType 'S' (State), same as CA/NJ

    vm.maritalStatusOptions = [
        { value: 'A', label: 'A. Single' },
        { value: 'B', label: 'B. Married Filing Separate or Married Filing Joint, both spouses working' },
        { value: 'C', label: 'C. Married Filing Joint, one spouse working' },
        { value: 'D', label: 'D. Head of Household' }
    ];

    // GA G-4 letter -> DB dbo.MaritalStatus.MaritalStatusID (like NJ maritalStatusMapping).
    // NOTE: confirm IDs — DB 4='Single or Married filing separately', 5='Married filing jointly', 6='Head of household'.
    vm.maritalStatusMapping = [
        { value: 'A', id: 4, label: 'Single' }, // Single
        { value: 'B', id: 10, label: 'Married Filing Separate or Married Filing Joint, both spouses working'}, // Married Filing Separate or MFJ both working (change later)
        { value: 'C', id: 11, label: 'Married Filing Joint, one spouse working' }, // MFJ one working
        { value: 'D', id: 6, label: 'Head of Household' } // Head of Household
    ];

    vm.$onInit = function () {
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }
        vm.reqReview = false;
        vm.date = moment(new Date(), 'MM/DD/YYYY').toDate();
        vm.stateProvinces = this.provinces;
        vm.userProfile = this.profile;

        vm.retrieveLocale()
            .then(function (locale) {
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;
            });

        if (vm.savedInputs != null && vm.savedInputs.FullName != null && !vm.ownerView) {
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
            prefillFromProfile();
        } else if (vm.userInputs != null && vm.userInputs.FullName != null) {
            if (this.application) {
                vm.editable = !(this.application && this.application.HasSW4Form !== null && this.application.ProvinceW4 !== 'Review' && this.application.ProvinceW4 !== 'Submitted' && this.application.ProvinceW4 !== 'Pending');
            }
            fillEmployee(vm.userInputs);
            prefillFromProfile();
        } else {
            prefillFromProfile();
        }
        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }
        vm.editable = resolveEditable();
        prefillEmployer();
        utilityService.hideLoading();
        if (vm.ownerView && vm.showSignaturePopup) {
            return onPreview();
        }
    }

    function prefillFromProfile() {
        vm.employeeName = [vm.employeeProfile.FirstName, vm.employeeProfile.MiddleName, vm.employeeProfile.LastName].filter(Boolean).join(' ');
        vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
        vm.address = [vm.profile.HomeAddress?.StreetLine1, vm.profile.HomeAddress?.StreetLine2, vm.profile.HomeAddress?.AptNum].filter(Boolean).join(', ');
        vm.city = vm.profile.HomeAddress?.City;
        vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
        vm.zipCode = vm.profile.HomeAddress?.PostalCode;
    }

    function prefillEmployer() {
        if (vm.employerNameAddress) {
            return; // already populated (e.g. from saved owner inputs)
        }
        if (vm.ownerInfo) {
            if (vm.ownerInfo.ShippingAddress) {
                const a = vm.ownerInfo.ShippingAddress;
                vm.employerNameAddress = [vm.ownerInfo.LegalBusinessName || vm.ownerInfo.ClientName, a.StreetLine1, a.StreetLine2, a.AptNum, a.City, a.StateName, a.PostalCode, a.CountryName].filter(Boolean).join(', ');
            } else {
                vm.employerNameAddress = [vm.ownerInfo.LegalBusinessName || vm.ownerInfo.ClientName].filter(Boolean).join(', ');
            }
            const sit = vm.stateTaxInfo && vm.stateTaxInfo.find(function (x) {
                return x.State === String(vm.employeeBankInfo && vm.employeeBankInfo.StateToBeTaxedIn) && x.Name === 'State Income Tax';
            });
            if (sit && !vm.employerWh) {
                vm.employerWh = sit.Value;
            }
        } else if (vm.owner) {
            vm.employerNameAddress = [vm.owner.LegalBusinessName || vm.owner.ClientName].filter(Boolean).join(', ');
        }
    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.ProvinceW4;
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }
        return !vm.application.HasSW4Form || formStatus === 'Pending' || formStatus === 'ReviewRequired';
    }

    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID === 1 && vm.application.ApplicationStatus === 'Pending') {
            prefillFromProfile();
        }
    }

    $scope.$watch('vm.taxForm.$dirty', function (value) {
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    // Kendo drop-downs hold the selected state object; mirror its StateName into the hidden inputs that carry form validation (user-profile pattern).
    $scope.$watch(function () {
        return vm.residenceStateOption;
    }, function (v) {
        vm.residenceState = (v && v.StateProvinceID != null) ? v.StateName : null;
    });
    $scope.$watch(function () {
        return vm.spouseResidenceStateOption;
    }, function (v) {
        vm.spouseResidenceState = (v && v.StateProvinceID != null) ? v.StateName : null;
    });

    function onSign() {
        return $uibModal.open({
            ...SignaturePadModal,
            resolve: { title: () => "Signature" }
        }).result.then(function (data) {
            vm.signimage = data;
        });
    }

    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '2');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );
    }

    function onShowI9() {
        vm.close({ $value: 'ok' });
    }

    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.taxForm && vm.taxForm.$dirty) {
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => "Your form is not completed yet. Do you want to leave?",
                    state: () => "application-status"
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }

    function onShowFederalW4() {
        if (vm.ownerView) {
            return $state.go('application-status.ownermodal.federalW4');
        }
        if (vm.taxForm && vm.taxForm.$dirty) {
            return $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => "Your form is not completed yet. Do you want to leave?",
                    state: () => "onboarding-document.federalW4"
                },
                size: 'sm',
                backdrop: 'static'
            }).result
        }
        return $state.go('onboarding-document.federalW4');
    }

    // Retrieved UserInput values are strings; type="number" inputs need a real number (or null,
    // else AngularJS throws "Expected `x` to be a number").
    function toNumOrNull(v) {
        if (v === null || v === undefined || v === "") {
            return null;
        }
        const n = Number(v);
        return isNaN(n) ? null : n;
    }
    function fillEmployee(application) {
        vm.employeeName = application.FullName;
        vm.employeeSsn = application.EmployeeSocialSecurityNumber;
        vm.address = application.HomeAddress;
        vm.cityStateZip = application.CityStateZip;
        vm.maritalStatusLetter = application.MaritalStatus;
        vm.dependentAllowances = toNumOrNull(application.DependentAllowances);
        vm.totalAllowances = toNumOrNull(application.TotalAllowances);
        vm.additionalWithholding = toNumOrNull(application.AdditionalWithholding);
        vm.exemptNoLiability = application.ExemptNoLiability === true || application.ExemptNoLiability === 'true';
        vm.exemptServicemember = application.ExemptServicemember === true || application.ExemptServicemember === 'true';
        vm.isExempt = !!(vm.exemptNoLiability || vm.exemptServicemember);
        vm.residenceState = application.ResidenceState;
        vm.spouseResidenceState = application.SpouseResidenceState;
        vm.residenceStateOption = (vm.stateProvinces || []).find(function (s) {
            return s.StateName === application.ResidenceState;
        }) || null;
        vm.spouseResidenceStateOption = (vm.stateProvinces || []).find(function (s) {
            return s.StateName === application.SpouseResidenceState;
        }) || null;
        vm.wsFederalAgi = toNumOrNull(application.WorksheetFederalAgi);
        vm.wsFederalDeductions = toNumOrNull(application.WorksheetFederalDeductions);
        vm.wsGeorgiaStandardDeduction = toNumOrNull(application.WorksheetGeorgiaStandardDeduction);
        vm.wsAllowableAdjustments = toNumOrNull(application.WorksheetAllowableAdjustments);
        vm.wsLine5c = toNumOrNull(application.WorksheetLine5c);
        vm.wsLine5e = toNumOrNull(application.WorksheetLine5e);
        vm.wsLine5g = toNumOrNull(application.WorksheetLine5g);
        vm.georgiaAdjustmentsAllowance = toNumOrNull(application.StateWithholding);
        vm.wsLine5h = toNumOrNull(application.WorksheetLine5h);
        vm.employerNameAddress = application.EmployerNameAddress;
        vm.employerFein = application.EmployerfederalEIN;
        vm.employerWh = application.EmployerWithholdingNumber;
        if (application.Date) {
            vm.date = moment(application.Date, 'MM/DD/YYYY').toDate();
        }
        if (application.Signature) {
            vm.signimage = application.Signature;
            vm.isSigned = true;
        }
        vm.prefilled = true;
    }

    // Step 7 Total Allowances: if the user modified it and then cleared it (touched + removed),
    // autofill 0 on preview/submit so the PDF shows 0. Untouched-empty stays blank; Save does not coerce.
    //function autofillTotalAllowancesOnFinalize() {
    //    //const ctrl = vm.taxForm && vm.taxForm.totalAllowances;
    //    //const empty = vm.totalAllowances == null || vm.totalAllowances === '';
    //    //if (!vm.isExempt && empty && ctrl && ctrl.$dirty) {
    //    //    vm.totalAllowances = 0;
    //    //    if (ctrl.$setViewValue) {
    //    //        ctrl.$setViewValue('0');
    //    //        ctrl.$render();
    //    //    }
    //    //}
    //}

    function buildFormData() {
        const data = {
            RequestTypeId: '2',
            IsI9EmployeeMode: !vm.ownerView,
            FullName: vm.employeeName,
            EmployeeSocialSecurityNumber: vm.employeeSsn,
            HomeAddress: vm.address,
            CityStateZip: [vm.city, vm.stateProvince && vm.stateProvince.Abbr, vm.zipCode].filter(Boolean).join(', ') || vm.cityStateZip,
            MaritalStatus: vm.maritalStatusLetter,
            DependentAllowances: vm.dependentAllowances,
            TotalAllowances: vm.totalAllowances, // leave blank when removed (no autofill 0)
            AdditionalWithholding: vm.additionalWithholding,
            ExemptNoLiability: vm.exemptNoLiability ? "true" : "false",
            ExemptServicemember: vm.exemptServicemember ? 'true' : 'false',
            ResidenceState: vm.residenceState,
            SpouseResidenceState: vm.spouseResidenceState,
            StateWithholding: vm.georgiaAdjustmentsAllowance, // Step 5 (Georgia Adjustments Allowance) -> state-withholding PDF field
            WorksheetFederalAgi: vm.wsFederalAgi,
            WorksheetFederalDeductions: vm.wsFederalDeductions,
            WorksheetGeorgiaStandardDeduction: vm.wsGeorgiaStandardDeduction,
            WorksheetAllowableAdjustments: vm.wsAllowableAdjustments,
            WorksheetLine5c: vm.wsLine5c,
            WorksheetLine5e: vm.wsLine5e,
            WorksheetLine5g: vm.wsLine5g,
            WorksheetLine5h: vm.wsLine5h,
            EmployerNameAddress: vm.employerNameAddress,
            EmployerfederalEIN: vm.employerFein,
            EmployerWithholdingNumber: vm.employerWh,
            Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            Signature: vm.signimage,
        };
        // FormRequest is all-string; JSON numbers do not bind to string props. Stringify everything
        // except the boolean IsI9EmployeeMode so numeric fields (allowances/worksheet) reach the PDF.
        Object.keys(data).forEach(function (k) {
            if (k === "IsI9EmployeeMode") {
                return;
            }
            data[k] = (data[k] === null || data[k] === undefined) ? "" : String(data[k]);
        });
        return data;
    }

    function onDocDownload(pages) {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '1', String(GA_STATE_ID), pages).then(function (result) {
            utilityService.hideLoading();
            return result;
        }).then(function () {
            utilityService.hideLoading();
        });
    }

    function onPreview() {
        //autofillTotalAllowancesOnFinalize();
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        const formData = buildFormData();
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, GA_STATE_ID)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...OwnerPreviewSignatureModal,
                    resolve: {
                        title: () => "State W4 - Georgia Preview",
                        previewUrl: () => vm.previewUrl,
                        allowApprove: () => canApproveForm(vm.application, '2'),
                        allowSign: () => false,
                        showSignaturePopup: () => vm.showSignaturePopup
                    }
                }).result
            }).then(function (data) {
                // Modal returns { dataUrl, success } on submit/approve, or the string 'cancel' on Close.
                // Only proceed on a real submit; do nothing on cancel/close (mirrors NJ).
                if (data && data.success) {
                    vm.employerSignimage = data.dataUrl;
                    vm.isSigned = true;
                    return onSubmit();
                }
            }).catch((err) => {
                utilityService.hideLoading();
                alert("Retrieving failed: " + utilityService.getExceptionMessage(err));
            });
    }

    function onPreviewInPage() {
        //autofillTotalAllowancesOnFinalize();
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        const formData = buildFormData();
        formData.Signature = undefined;
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, GA_STATE_ID)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...PreviewSignatureModal,
                    resolve: {
                        title: () => "State W4 - Georgia Preview",
                        previewUrl: () => vm.previewUrl
                    }
                }).result
            }).then(function (data) {
                // X button resolves with undefined; guard so closing without signing does not error/submit.
                if (!data || !data.dataUrl) {
                    utilityService.hideLoading();
                    return;
                }
                vm.signimage = data.dataUrl;
                vm.isSigned = data.dataUrl != null;
                return onSubmit();
            }).catch((err) => {
                utilityService.hideLoading();
                // Ignore user-initiated dismissals (Cancel / backdrop / escape); only surface real errors.
                if (err === 'cancel' || err === 'backdrop click' || err === 'escape key press' || err === undefined) {
                    return;
                }
                alert("Retrieving failed: " + utilityService.getExceptionMessage(err));
            });
    }

    function onSave() {
        utilityService.showLoading();
        const formData = buildFormData();
        return onboardingDocumentService.save(vm.employee.UserName, formData, GA_STATE_ID).then(function () {
            vm.isSaved = true;
            vm.showSavedNotification = true;
            vm.taxForm.$setPristine();
            return utilityService.hideLoading();
        });
    }

    function toNum(v) {
        return (v != null && v !== "") ? Number(v) : 0;
    }

    // Step 8: when either exempt box is checked, Steps 4-7 + worksheet must be blank in the digital form.
    // True when Step 4 (Dependent Allowances) has any entry, including 0.
    function step4Filled() {
        return vm.dependentAllowances !== null && vm.dependentAllowances !== undefined && vm.dependentAllowances !== "";
    }

    // True when Step 5 (Georgia Adjustments Allowance = worksheet H) has any entry, including 0.
    function step5Filled() {
        return vm.georgiaAdjustmentsAllowance !== null && vm.georgiaAdjustmentsAllowance !== undefined && vm.georgiaAdjustmentsAllowance !== "";
    }

    function onExemptChange() {
        vm.isExempt = !!(vm.exemptNoLiability || vm.exemptServicemember);
        if (!vm.exemptServicemember) {
            // 8(b) residence fields are only enabled when 8(b) is checked.
            vm.residenceState = null;
            vm.spouseResidenceState = null;
            vm.residenceStateOption = null;
            vm.spouseResidenceStateOption = null;
        }
        if (vm.isExempt) {
            vm.dependentAllowances = null; // Step 4
            vm.georgiaAdjustmentsAllowance = null; // Step 5 (Georgia Adjustments Allowance)
            vm.wsLine5h = null; // Worksheet H
            vm.additionalWithholding = null; // Step 6
            vm.maritalStatusLetter = null; // Step 7 letter
            vm.totalAllowances = null; // Step 7 total
            vm.wsFederalDeductions = null; // Worksheet A
            vm.wsGeorgiaStandardDeduction = null;// Worksheet B
            vm.wsLine5c = null; // Worksheet C
            vm.wsAllowableAdjustments = null; // Worksheet D
            vm.wsLine5e = null; // Worksheet E
            vm.wsFederalAgi = null; // Worksheet F
            vm.wsLine5g = null; // Worksheet G
        }
    }

    function syncFormToProfile() {
        // Z: State Marital Status - map GA letter -> DB MaritalStatusID.
        const mapped = vm.maritalStatusMapping.find(function (x) {
            return x.value === vm.maritalStatusLetter;
        });
        const mappedId = mapped ? mapped.id : null;
        if (mappedId != null && Array.isArray(vm.maritalStatus)) {
            const match = vm.maritalStatus.find(function (item) {
                return item.MaritalStatusID === mappedId;
            });
            if (match) {
                vm.employeeBankInfo.StateMaritalStatusID = match.MaritalStatusID;
                // Column Z override: show the GA marital-status text (e.g. "Single"), not the letter
                //const selectedMarital = vm.maritalStatusOptions.find(function (o) {
                //    return o.value === vm.maritalStatusLetter;
                //});
                vm.employeeBankInfo.StateMaritalStatusParams = mapped.label;
            }
        }
        
        // AA: Total State Allowances (Step 7 total)
        vm.employeeBankInfo.RegularWithholdingAllowances = toNum(vm.georgiaAdjustmentsAllowance);
        // AB: Dependent Allowances (Step 4)
        vm.employeeBankInfo.DependentAllowances = toNum(vm.dependentAllowances);
        // AC: Additional Depend Allowances (Step 5 - Georgia Adjustments Allowance)
        //vm.employeeBankInfo.AdditionalDependentAllowances = toNum(vm.wsLine5h);
        // AE: State Withholding Amount (S) - Step 6, stored on the STATE withholding type (like CA/NJ).
        const stateAmt = toNum(vm.additionalWithholding);
        vm.employeeBankInfo.EmployeeWithholdingInfos = (vm.employeeBankInfo.EmployeeWithholdingInfos || []).filter(
            function (x) {
                return x.WithholdingTypeID !== vm.stateWitholdingTypeID;
            });
        if (stateAmt > 0) {
            vm.employeeBankInfo.EmployeeWithholdingInfos.push({ EmployeeId: vm.employee.EmployeeID, WithholdingTypeID: vm.stateWitholdingTypeID, AdditionalWithholdingAmount: stateAmt });
        }
        // AF: State Exempt (Step 8)
        // 8(b) servicemember exemption only applies when employee and spouse share the same state of residence.
        vm.employeeBankInfo.StateTaxExempt = !!(vm.exemptNoLiability || (vm.exemptServicemember && vm.residenceState && vm.spouseResidenceState && vm.residenceState === vm.spouseResidenceState));
        // AD: Adopted Child Allowances - no GA form field; left unchanged.
    }

    function onApprove() {
        const approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "2");
        const trans = $q.all(approvePromise).then((res) => {
            if (res) {
                vm.onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Approve failed")
        );
    }

    function onSubmit() {
        //autofillTotalAllowancesOnFinalize();
        // NOTE: no showLoading() here - showLoadingUntilResolved(trans) below owns the spinner;
        // an extra unpaired showLoading() left loadingCount > 0 and the spinner never hid (matches NJ).
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return utilityService.hideLoading();
        }
        const updatePromises = [];
        vm.isDirtyEdit = vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID !== 2 && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending' && (vm.application.ProvinceW4 === 'Approved' || vm.application.ProvinceW4 === 'Pending');
        if ((vm.taxForm && vm.taxForm.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isDirtyEdit || isPendingResubmit || vm.isSigned || vm.application.ProvinceW4 === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading();
                alert("Preview and Signature are required");
                return;
            }
            if (!vm.signimage) {
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }
            const formData = buildFormData();
            if (!vm.ownerView) {
                syncFormToProfile();
                updatePromises.push(() => employeeService.updateEmployeeOnboardingBankInfo(vm.employee.EmployeeID, vm.employeeBankInfo));
            }
            updatePromises.push(() => onboardingDocumentService.submit(vm.employee.UserName, formData, GA_STATE_ID));
        }
        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }
        const trans = updatePromises.reduce((chain, promise) => {
            return chain.then(() => (typeof promise === 'function' ? promise() : promise));
        }, $q.resolve()).then((res) => {
            // Close/advance unconditionally once the chain resolves (mirrors NJ); submit may
            // resolve with a falsy value, so gating on `res` left the modal open.
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });
        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
    }

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                return translations;
            });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                return locales.filter(function (locale) {
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function ssnIsValidated() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.ssnChanged) {
            if ((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) {
                return false;
            }
        }
        return true;
    }

    function ssnBlur() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.SSN !== vm.employeeBankInfo.originalSSN) {
            vm.employeeBankInfo.ssnChanged = true;
        } else {
            vm.employeeBankInfo.ssnChanged = false;
        }
    }

    function formatSsn(ssn) {
        if (!ssn) return "";
        var digits = ("" + ssn).replace(/[^0-9]/g, "");
        if (digits.length !== 9) return ssn;
        var mask = vm.employeeBankInfo
            && vm.employeeBankInfo.Translations
            && vm.employeeBankInfo.Translations.SSNMask;
        if (mask === "000-000-000") {
            return digits.slice(0, 3) + "-" + digits.slice(3, 6) + "-" + digits.slice(6, 9);
        }
        return digits.slice(0, 3) + "-" + digits.slice(3, 5) + "-" + digits.slice(5, 9);
    }

    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
    function revealFEINChar(fein, char, i) {
        return i > 4;
    }
}

export const GAW4Modal = {
    component: "apexGAW4Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
